import { ReactNode } from 'react';
import {
  Public, Flight, Language, Category, Payments, Badge, Contacts, SupportAgent,
  Settings, AccountBalance, Stars, Event, Subscriptions, DirectionsCar,
  Restaurant, ShoppingCart, Build, Storage, Dashboard, People, Psychology,
  AccountTree, AccountBalanceWallet, LocalOffer, Notifications, CreditCard,
  Sms, Translate, Description,   Security, Assessment, Business, Hotel,
  DirectionsBus, Train, CarRental, CardTravel, LocalPharmacy, MedicalServices,
  Inventory, LocalShipping, Store, Storefront, Handyman, Flag, Route,
  TwoWheeler, LocalTaxi, DeliveryDining, Videocam, Home, Edit, Star,
  PostAdd, ModeEdit, Garage, Map, MyLocation, ShoppingBag, CalendarMonth,
  Schedule, ConfirmationNumber,   Person, Phone,
  ElectricalServices, Plumbing, CleaningServices, AcUnit, FaceRetouchingNatural, Spa,
  SelfImprovement, FitnessCenter, Gavel, School, LocalFlorist, WaterDrop, Medication, Handshake,
  QrCode, EventSeat, ShoppingBasket, History, Assignment,   MenuBook, ReceiptLong, EventNote,
  VerifiedUser, AssignmentInd, ManageSearch, CheckCircle, ToggleOn, Group, WorkspacePremium,
  ViewCarousel, Campaign, Extension, VpnKey, SystemUpdate, Share, GroupAdd,
} from '@mui/icons-material';

const ICON_MAP: Record<string, ReactNode> = {
  Public: <Public fontSize="small" />,
  Flight: <Flight fontSize="small" />,
  Language: <Language fontSize="small" />,
  Category: <Category fontSize="small" />,
  Payments: <Payments fontSize="small" />,
  Badge: <Badge fontSize="small" />,
  Handshake: <Handshake fontSize="small" />,
  Contacts: <Contacts fontSize="small" />,
  SupportAgent: <SupportAgent fontSize="small" />,
  Settings: <Settings fontSize="small" />,
  AccountBalance: <AccountBalance fontSize="small" />,
  Stars: <Stars fontSize="small" />,
  Event: <Event fontSize="small" />,
  Subscriptions: <Subscriptions fontSize="small" />,
  DirectionsCar: <DirectionsCar fontSize="small" />,
  Restaurant: <Restaurant fontSize="small" />,
  ShoppingCart: <ShoppingCart fontSize="small" />,
  Build: <Build fontSize="small" />,
  Storage: <Storage fontSize="small" />,
  Dashboard: <Dashboard fontSize="small" />,
  People: <People fontSize="small" />,
  Group: <Group fontSize="small" />,
  Psychology: <Psychology fontSize="small" />,
  AccountTree: <AccountTree fontSize="small" />,
  AccountBalanceWallet: <AccountBalanceWallet fontSize="small" />,
  LocalOffer: <LocalOffer fontSize="small" />,
  Notifications: <Notifications fontSize="small" />,
  CreditCard: <CreditCard fontSize="small" />,
  Sms: <Sms fontSize="small" />,
  Translate: <Translate fontSize="small" />,
  Description: <Description fontSize="small" />,
  Security: <Security fontSize="small" />,
  Assessment: <Assessment fontSize="small" />,
  Business: <Business fontSize="small" />,
  WorkspacePremium: <WorkspacePremium fontSize="small" />,
  VpnKey: <VpnKey fontSize="small" />,
  SystemUpdate: <SystemUpdate fontSize="small" />,
  Hotel: <Hotel fontSize="small" />,
  DirectionsBus: <DirectionsBus fontSize="small" />,
  Train: <Train fontSize="small" />,
  CarRental: <CarRental fontSize="small" />,
  CardTravel: <CardTravel fontSize="small" />,
  LocalPharmacy: <LocalPharmacy fontSize="small" />,
  MedicalServices: <MedicalServices fontSize="small" />,
  Inventory: <Inventory fontSize="small" />,
  LocalShipping: <LocalShipping fontSize="small" />,
  Store: <Store fontSize="small" />,
  Storefront: <Storefront fontSize="small" />,
  Handyman: <Handyman fontSize="small" />,
  Flag: <Flag fontSize="small" />,
  TwoWheeler: <TwoWheeler fontSize="small" />,
  LocalTaxi: <LocalTaxi fontSize="small" />,
  Motorcycle: <TwoWheeler fontSize="small" />,
  DeliveryDining: <DeliveryDining fontSize="small" />,
  Videocam: <Videocam fontSize="small" />,
  Home: <Home fontSize="small" />,
  Edit: <Edit fontSize="small" />,
  PostAdd: <PostAdd fontSize="small" />,
  ModeEdit: <ModeEdit fontSize="small" />,
  Star: <Star fontSize="small" />,
  ElectricalServices: <ElectricalServices fontSize="small" />,
  Plumbing: <Plumbing fontSize="small" />,
  CleaningServices: <CleaningServices fontSize="small" />,
  AcUnit: <AcUnit fontSize="small" />,
  FaceRetouchingNatural: <FaceRetouchingNatural fontSize="small" />,
  Spa: <Spa fontSize="small" />,
  SelfImprovement: <SelfImprovement fontSize="small" />,
  FitnessCenter: <FitnessCenter fontSize="small" />,
  Gavel: <Gavel fontSize="small" />,
  School: <School fontSize="small" />,
  LocalFlorist: <LocalFlorist fontSize="small" />,
  WaterDrop: <WaterDrop fontSize="small" />,
  Medication: <Medication fontSize="small" />,
  LocalBar: <Store fontSize="small" />,
  Movie: <Event fontSize="small" />,
  ContentCut: <FaceRetouchingNatural fontSize="small" />,
  LocalHospital: <MedicalServices fontSize="small" />,
  AirportShuttle: <DirectionsCar fontSize="small" />,
  BuildCircle: <Build fontSize="small" />,
  MiscellaneousServices: <Category fontSize="small" />,
  Garage: <Garage fontSize="small" />,
  Map: <Map fontSize="small" />,
  MyLocation: <MyLocation fontSize="small" />,
  ShoppingBag: <ShoppingBag fontSize="small" />,
  CalendarMonth: <CalendarMonth fontSize="small" />,
  Schedule: <Schedule fontSize="small" />,
  ConfirmationNumber: <ConfirmationNumber fontSize="small" />,
  Person: <Person fontSize="small" />,
  Phone: <Phone fontSize="small" />,
  ElectricRickshaw: <TwoWheeler fontSize="small" />,
  Route: <Route fontSize="small" />,
  Hub: <Category fontSize="small" />,
  Tune: <Settings fontSize="small" />,
  Palette: <Category fontSize="small" />,
  QrCode: <QrCode fontSize="small" />,
  EventSeat: <EventSeat fontSize="small" />,
  ShoppingBasket: <ShoppingBasket fontSize="small" />,
  History: <History fontSize="small" />,
  Assignment: <Assignment fontSize="small" />,
  MenuBook: <MenuBook fontSize="small" />,
  ReceiptLong: <ReceiptLong fontSize="small" />,
  EventNote: <EventNote fontSize="small" />,
  VerifiedUser: <VerifiedUser fontSize="small" />,
  AssignmentInd: <AssignmentInd fontSize="small" />,
  ManageSearch: <ManageSearch fontSize="small" />,
  CheckCircle: <CheckCircle fontSize="small" />,
  ToggleOn: <ToggleOn fontSize="small" />,
  ViewCarousel: <ViewCarousel fontSize="small" />,
  Campaign: <Campaign fontSize="small" />,
  Extension: <Extension fontSize="small" />,
  Share: <Share fontSize="small" />,
  GroupAdd: <GroupAdd fontSize="small" />,
};

export function resolveServiceIcon(iconName?: string): ReactNode {
  if (!iconName) return ICON_MAP.Build;
  const key = iconName.trim();
  if (ICON_MAP[key]) return ICON_MAP[key];
  // tolerate lowercase / kebab from legacy data
  const normalized = key
    .replace(/[-_\s]+(.)?/g, (_, c: string) => (c ? c.toUpperCase() : ''))
    .replace(/^./, (c) => c.toUpperCase());
  if (ICON_MAP[normalized]) return ICON_MAP[normalized];
  return ICON_MAP.Build;
}

export { ICON_MAP };
